import { connect } from 'react-redux';
import View from './LtcNeedsView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  principalStartAgeSelector,
  principalDurationSelector,
  spouseStartAgeSelector,
  spouseDurationSelector,
  principalNameSelector,
  spouseNameSelector,
  hasSpouseSelector,
  spouseLtcStartAgeOptionsSelector,
  principalLtcStartAgeOptionsSelector,
  durationOptionsSelector,
} from './LtcNeedsSelector';
import { updateWhatIfsData } from '../../WhatIfsActions';
import {
  areOptionsLoaded,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  whatIfTypeSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  whatIfType: whatIfTypeSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  principalStartAge: principalStartAgeSelector(state, ownProps),
  principalDuration: principalDurationSelector(state, ownProps),
  spouseStartAge: spouseStartAgeSelector(state, ownProps),
  spouseDuration: spouseDurationSelector(state, ownProps),
  principalName: principalNameSelector(state, ownProps),
  spouseName: spouseNameSelector(state, ownProps),
  hasSpouse: hasSpouseSelector(state, ownProps),
  spouseLtcStartAgeOptions: spouseLtcStartAgeOptionsSelector(state, ownProps),
  principalLtcStartAgeOptions: principalLtcStartAgeOptionsSelector(state, ownProps),
  durationOptions: durationOptionsSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
